import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { Popconfirm } from 'kts-components-antd-x4';
import { PageHeaderFoot, Prompt, Button, AutoTableContainer, Pagination, Table } from 'kts-xui';
import { AdvancedSearch, KtsForm } from 'kts-components'; 
import ModalCompanyDetail from './UI.Network.Modal.CompanyDetail';
import { network, } from 'src/api';

import ModalBatchInvitation from './UI.Network.Modal.Invitation.Batch';
import LinkModal from './UI.Network.Modal.Link';
import ModalInvitation from './UI.Network.Modal.Invitation';
const css = require('./index.scss');
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    public columns = [
        {
            title: '公司名称',
            dataIndex: 'name',
            width: 210,
        },
        {
            title: '纳税人识别号',
            dataIndex: 'taxId',
            width: 130,
        },
        {
            title: '国家或地区',
            dataIndex: ['location', 'country'],
            width: 100,
        },
        {
            title: '城市',
            dataIndex: ['location', 'city'],
            width: 100,
        },
        {
            title: '操作',
            dataIndex: 'operate',
            width: 100,
            render: (text, record) => {
                if (record.connectionState === 1) {
                    return (
                        <div>
                            <a onClick={this.onShowCompanyDetailModal.bind(this, record)} >查看 </a>
                            <Popconfirm
                                title={
                                    <div>
                                        <div> 您是否确定取消与该公司的网络连接？</div>
                                        <div className={`${css.smtips}`}> 取消连接后该公司将从您公司的网络中移除</div>
                                    </div>
                                }
                                onConfirm={this.onCancelRelation.bind(this, record)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <a>取消</a>
                            </Popconfirm>
                        </div>
                    );
                } else {
                    return (
                        <div>
                            <a onClick={this.onShowCompanyDetailModal.bind(this, record)} >查看 </a>
                            <a onClick={this.onCreateRelation.bind(this, record)} >连接</a>
                        </div>
                    );
                }
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            batchModal: false,
            inviteModal: false,
            linkModal: false,
            pageMeta: null,
            list: [],
            params: {},
        };
    }
    /** 查看详情 */
    private onShowCompanyDetailModal = (params) => {
        ModulesAction.networkCompayDetailNew(params.companyId, params.connectionState);
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            Components: <ModalCompanyDetail />,
            title: '详情'
        });
    }
    /** 发送连接请求 */
    private onCreateRelation = (rec) => {
        ModulesAction.sendRelation({
            targetCompanyId: rec.companyId,
            targetTaxId: rec.taxId
        });
    }
    /** 取消关联 */
    private onCancelRelation = (rec) => {
        ModulesAction.sendCancelRelation({
            connectCompanyId: rec.companyId,
        }, this.onRefresh);
    }

    topExpand = () => {
        return (
            <AdvancedSearch
                width={480}
                height={44}
                compact={true}
                defaultKey="name"
                placeholder="请输入公司名称"
                searchFormSubmit={this.onSearch}
            >
                <KtsForm
                    labelCol={9}
                    wrapperCol={15}
                    labelAlign="left"
                    compact={true}
                    schema={{
                        type: 'object',
                        properties: {
                            name: {
                                type: 'string',
                                title: '公司名称',
                            },
                            taxId: {
                                type: 'string',
                                title: '纳税人识别号',
                            },
                        },
                    }}
                >
                </KtsForm>
            </AdvancedSearch>
        );
    }

    componentDidMount() {
        const params = {
            pageNum: 1,
            pageSize: 10
        };
        this.getData(params);
    }
    getData = async (params?: any) => {
        if (!params.name && !params.taxId) {
            return;
        }
        let res = await network.platformNetworkList(this, params);
        if (!res.er) {
            this.setState({
                pageMeta: res.res.pageMeta,
                list: res.res.items
            });
        }
    }
    onPageChange = (pageNum, pageSize) => {
        this.setState({
            pageMeta: {
                ...this.state.pageMeta,
                pageNum,
                pageSize
            }
        }, () => {
            this.onRefresh();
        });
    }
    onRefresh = () => {
        const params = {
            ...this.state.params,
            ...this.state.pageMeta,
        };
        this.getData(params);
    }
    onSearch = (data: any = {}) => {

        this.setState({
            params: data
        });
        const params = {
            ...data,
            pageSize: 20,
            ...this.state.pageMeta,
            pageNum: 1,

        };
        this.getData(params);
    }
    showPublicLinkModal = async () => {
        this.setState({
            linkModal: true
        });
    }
    onShowInvitationModal = () => {
        this.setState({
            inviteModal: true
        });
    }
    onCloseInvitation = () => {
        this.setState({
            inviteModal: false
        });
    }
    onShowBatchInvitationModal = () => {
        this.setState({
            batchModal: true
        });
    }
    onCloseBatch = () => {
        this.setState({
            batchModal: false
        });
    }
    onCloseLink = () => {
        this.setState({
            linkModal: false
        });
    }
    render() {
        const dataSource = this.modulesState.statePlatform.list;
        const { user } = MyStore.instance.getState();
        const { inviteModal, batchModal, linkModal, list, pageMeta } = this.state;
        return (
            <div style={{ height: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 'none', position: 'relative', zIndex: 1 }} className="special">
                    <PageHeaderFoot
                        expandLeft={this.topExpand()}
                        expandRight={[
                            <Button key='0' type="primary" onClick={this.showPublicLinkModal}>获取公共邀请链接</Button>,
                            <Button key='1' type="primary" onClick={this.onShowInvitationModal} >
                                邀请公司
                            </Button>,
                            <Button type="default" key='2' onClick={this.onShowBatchInvitationModal} >
                                批量邀请
                            </Button>
                        ]}
                        onRefresh={this.onRefresh}
                    >

                    </PageHeaderFoot>
                </div>
                <AutoTableContainer style={{ flex: 1, padding: '0 20px', backgroundColor: '#efefef' }} >
                    <Table
                        bordered={true}
                        dataSource={list}
                        columns={this.columns as any[]}
                        scroll={{ x: '1200', y: 'max-content' }}
                        pagination={false}
                    />

                </AutoTableContainer>
                {pageMeta && <Pagination onChange={this.onPageChange} showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条,  共有 ${total} 条`} style={{ padding: '16px 0', flex: 'none', background: 'white', textAlign: 'center' }} total={pageMeta.total} pageSize={pageMeta.pageSize} current={pageMeta.pageNum} showSizeChanger={true} />}
                {linkModal && <LinkModal onClose={this.onCloseLink} />}
                {batchModal && <ModalBatchInvitation onClose={this.onCloseBatch} />}
                {inviteModal && <ModalInvitation onClose={this.onCloseInvitation} />}
                {/* <Pagination onChange={this.onPageChange} style={{ padding: '16px 0', flex: 'none', background: 'white', textAlign: 'center' }} total={pageMeta.total} pageSize={pageMeta.pageSize} current={pageMeta.pageNum} showSizeChanger={true} /> */}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Invite.tsx